import { render, staticRenderFns } from "./ContentView.vue?vue&type=template&id=a2e0bcc8&scoped=true"
import script from "./ContentView.vue?vue&type=script&lang=js"
export * from "./ContentView.vue?vue&type=script&lang=js"
import style0 from "./ContentView.vue?vue&type=style&index=0&id=a2e0bcc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e0bcc8",
  null
  
)

export default component.exports